"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonolithUserService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var helper_1 = require("../helper");
var ApplicationApi_service_1 = require("./jsonServiceApi/ApplicationApi.service");
var Credential_service_1 = require("./jsonServiceApi/Credential.service");
var Http_service_1 = require("../../core/services/http/Http.service");
var MonolithUserService = /** @class */ (function () {
    function MonolithUserService(applicationApiService, credentialService, seismicHelper, httpService) {
        this.applicationApiService = applicationApiService;
        this.credentialService = credentialService;
        this.seismicHelper = seismicHelper;
        this.httpService = httpService;
        this.httpService.addInterceptor(this);
    }
    /**
     * Used to override the token that will be used in GlobalHeadersService
     * @param token
     */
    MonolithUserService.prototype.setAccessToken = function (token) {
        this.overrideToken = token;
    };
    /**
     * @param withType
     * @deprecated
     * Please use CredentialsService.getAccessToken
     */
    MonolithUserService.prototype.getAccessToken = function (withType) {
        if (withType === void 0) { withType = true; }
        return this.overrideToken || this.credentialService.getAccessToken(withType); //bridge
    };
    /**
     * @deprecated
     * **Please stop using this!**
     *
     * Please use **CredentialService.getSecurityCredentials()** instead if you are need these props
     * ``` loginInfo.tenant
     *  loginInfo.username
     *  loginInfo.userid
     *  loginInfo.accessKey
     *  loginInfo.isSSO
     *  loginInfo.SSODisabled
     *  loginInfo.rememberMeToken
     *```
     * Otherwise, please see the progress bellow
     * 1. Check https://seismic.atlassian.net/browse/FEARCH-145 for analyzing
     * 2. Check https://seismic.atlassian.net/browse/FEARCH-395 for the following actions
     * 3. Check https://seismic-software.slack.com/archives/C028EJWVCC8 for more announcements
     */
    MonolithUserService.prototype.getLoginInfo = function () {
        return this.credentialService.getLoginInfo(); //bridge
    };
    /**
     * @deprecated
     * Please use `credentialService.getSecurityCredentials` instead
     */
    MonolithUserService.prototype.getSecurityCredentials = function () {
        return this.credentialService.getSecurityCredentials(); //bridge
    };
    /**
     * @deprecated
     * Please use `credentialService.initSecurityCredentials` instead
     * Only for initialization
     */
    MonolithUserService.prototype.initSecurityCredentials = function (securityCredentials) {
        return this.credentialService.initSecurityCredentials(securityCredentials); //bridge
    };
    /**
     * @deprecated
     * Please use `tenantService.getTenantUniqueId()` or `tenantService.getTenantName()` instead.
     *
     * Please notice these principles as well https://seismic.atlassian.net/wiki/spaces/FEC/pages/3044446130/Tenant+Subdomain+Solution#Principles.
     */
    MonolithUserService.prototype.getTenant = function () {
        return this.seismicHelper.getTenant(); //bridge
    };
    MonolithUserService.prototype.isLoggedIn = function () {
        return false;
    };
    MonolithUserService.prototype.getUserName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user.userName];
                }
            });
        });
    };
    MonolithUserService.prototype.getFullName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, user.firstName + ' ' + user.lastName];
                }
            });
        });
    };
    MonolithUserService.prototype.getUserNameInitials = function (firstName, lastName, userName) {
        var nameInitials = '';
        if (firstName && lastName) {
            nameInitials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
        }
        else if (userName) {
            nameInitials = userName.charAt(0).toUpperCase();
        }
        return nameInitials;
    };
    MonolithUserService.prototype.getCurrentUserNameInitials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var user, nameInitials;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.applicationApiService.getCurrentUser()];
                    case 1:
                        user = _a.sent();
                        nameInitials = this.getUserNameInitials(user.firstName, user.lastName, user.userName);
                        return [2 /*return*/, nameInitials];
                }
            });
        });
    };
    MonolithUserService.prototype.intercept = function (request, next) {
        if (request.options.ignoreGlobalHeaders || !this.getAccessToken()) {
            return next.handle(request);
        }
        return next.handle(request.clone({
            headers: {
                Authorization: this.getAccessToken(),
            },
        }));
    };
    MonolithUserService = __decorate([
        CommonService_decorator_1.CommonService('UserService'),
        __metadata("design:paramtypes", [ApplicationApi_service_1.ApplicationApiService,
            Credential_service_1.CredentialService,
            helper_1.SeismicHelper,
            Http_service_1.HttpService])
    ], MonolithUserService);
    return MonolithUserService;
}());
exports.MonolithUserService = MonolithUserService;
//# sourceMappingURL=MonolithUser.service.js.map